module.exports = __webpack_public_path__ + "assets/img/dayu_loding.238f42fe.png";